export const INTELLIGENCE = {
  path: 'intelligence',
  data: {
    breadcrumb: 'MENU_ADMIN.INTELLIGENCE_REPORTS',
    icon: 'pi pi-chart-bar',
    clickable: false,
    openTab: true
  },
  financialReports: {
    path: 'financial',
    data: {
      breadcrumb: 'MENU_ADMIN.INTELLIGENCE_REPORTS_SUB.FINANCIAL_REPORTS',
      icon: 'pi pi-chart-line',
      openTab: true
    }
  },
  incidentReports: {
    path: 'incidents',
    data: {
      breadcrumb: 'MENU_ADMIN.INTELLIGENCE_REPORTS_SUB.INCIDENT_REPORTS',
      icon: 'pi pi-chart-bar',
      openTab: true
    }
  },
  communityReports: {
    path: 'community',
    data: {
      breadcrumb: 'MENU_ADMIN.INTELLIGENCE_REPORTS_SUB.COMMUNITY_REPORTS',
      icon: 'pi pi-chart-pie',
      openTab: true
    }
  },
  kpis: {
    path: 'kpis',
    data: {
      breadcrumb: 'MENU_ADMIN.INTELLIGENCE_REPORTS_SUB.CUSTOMIZABLE_KPIS',
      icon: 'pi pi-sliders-h',
      openTab: true
    }
  },
  biIntegration: {
    path: 'bi',
    data: {
      breadcrumb: 'MENU_ADMIN.INTELLIGENCE_REPORTS_SUB.BI_INTEGRATION',
      icon: 'pi pi-external-link',
      openTab: true
    }
  }
};

